import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Particle from "../Particle";
import Resumecontent from "./ResumeContent";
import pdf from "../../Assets/Chengguang Li-Resume.pdf";
import { AiOutlineDownload } from "react-icons/ai";

function Resume() {
	return (
		<Container fluid className="resume-section">
			<Particle />
			<Container>
				<Row style={{ justifyContent: "center", position: "relative" }}>
					<Button variant="primary" href={pdf} target="_blank">
						<AiOutlineDownload />
						&nbsp;Download CV
					</Button>
				</Row>
				<Row className="resume">
					<Col md={6} className="resume-left">
						<h3 className="resume-title">Extracurricular Activities</h3>
						<Resumecontent
							title="INDUSTRIAL AND COMMERCIAL BANK OF CHINA"
							date="Mar 2022 - Presen"
							content={[
								"Developed an Html5 application for housing decoration loan application using React.js, React Router, state management tool, Webpack, and extra technologies and Worked as a front-end developer with senior consultants (developers, designers, UX designers, and project/product managers) on Agile teams. Three months after the system went live, it now has 300,000 users.",
								`Developed the microservices to provide the cash installment loan application feature using Spring Boot and Dubbo framework.`,
								`Solved the historical left security vulnerability that tampering with Cookie leads to illegal login into the system.`,
								`Led the front-end automation testing project from scratch to production and Solved the difficult technical problems encountered in the project through self-study. As a result, time-consuming and error-prone manual testing was replaced by an elegant automated testing solution, which increased testing efficiency 20 times and test correctness can be guaranteed.`,
							    `Led a standard solution for all applications so that the system-specified pages cannot be screenshotted, copied, and pasted, and it is compatible with all common browsers.`
							]}
						/>
						<Resumecontent
							title="Bubble8Up Mall platform"
							date="Jul. 2021 - Sep. 2021"
							content={[
								"Worked on Creating the Frontend-End of the Website Using Next.js && Javascript",
								`Developed the Shipping Box Size Calculation Function && the Minimum Shipping Fee Calculation Function`,
							]}
						/>
						<h3 className="resume-title"> Education</h3>
						<Resumecontent
							title="Monash University"
							date="2019 - 2021"
							content={[`Master of Information Technology`]}
						/>
						<Resumecontent
							title="Chengdu College of University of Electronic Science and Technology of China"
							date="2014 - 2018"
							content={[
								`Bachelor of Communication and Information Engineering`,
							]}
						/>
					</Col>
					<Col md={6} className="resume-right">
						<h3 className="resume-title"> Ranks and Achivements</h3>
						<Resumecontent
							title=""
							content={[
								`Won first place among 46 teams participating in the bank-wide project research, and the project is already being used in production.`,
								`Top Performance in LeetCode Weekly Contest:  200`,
								`June LeetCode Challenge Badge`,
								`July LeetCode Challenge Badge`,
								`Finished Problems in LeetCode:  260`,
								`Lan Qiao Cup Programming Contest：Third Prize`,
								`The Second Prize Scholarships Twice`,
								`Outstanding Graduates`,
							]}
						/>
					</Col>
				</Row>
				<Row style={{ justifyContent: "center", position: "relative" }}>
					<Button variant="primary" href={pdf} target="_blank">
						<AiOutlineDownload />
						&nbsp;Download CV
					</Button>
				</Row>
			</Container>
		</Container>
	);
}
export default Resume;
